import React, { memo, useEffect, useState } from 'react';
import EStyleSheet from 'react-native-extended-stylesheet';
import { View, ActivityIndicator, ScrollView, Text, FlatList } from 'react-native';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { BlackPortal } from 'react-native-portal';
import { useParams, useHistory } from '../../../../services/router';
import ButtonHeader from '../../../../components/ButtonHeader';
import IconListControl from '../../../../components/IconListControl';
import Paragraph from '../../../../components/Content/Paragraph';
import Content from '../../../../components/Content/Content';
import SubTitle from '../../../../components/Content/SubTitle';
import Separator from '../../../../components/Separator';
import { t } from '../../../../services/i18n';
import styles from './styles';
import ChecklistResponseItem from '../../../../components/ChecklistResponseItem';
import ENUM_TYPE_CHECKLIST from '../../../../constants/enumTypeChecklist';
import { makeSelectButtons } from '../../../../providers/ButtonsProvider/selectors';
import { makeSelectLocations } from '../../../../providers/LocationsProvider/selectors';
import { loadChecklist, deleteCurrentInProgress, resetLoading, sendResponseResetLoader, loadResponses } from '../../../../providers/ChecklistProvider/actions';
import {
	makeSelectChecklistsLoading,
	makeSelectChecklistsInProgress,
	makeSelectChecklists,
	makeSelectResponses,
	makeSelectResponsessLoading,
	makeSelectChecklistsError,
	makeSelectQueChecklists,
	makeSelectChecklistsLoadingSendResponse,
} from '../../../../providers/ChecklistProvider/selectors';
import FloatActionButton from '../../FloatActionButton';
import Alert from '../../../../services/alert';
import { loadButtons } from '../../../../providers/ButtonsProvider/actions';
import decodeCMSEncoding from '../../../../utils/decodeCMSEncoding';
import ContactPerson from '../../../../components/ContactPerson';
import { makeSelectNetworkIsConnected } from '../../../../selectors';
import mapQuestions from '../../../../services/checklist';
import convertQueCheckList from '../../../../services/checklist';
import moment from 'moment';
import { TouchableOpacity } from 'react-native';
import Control from '../../../../components/Control';
import AsyncStorage from '@react-native-async-storage/async-storage';
import login from '../../../../services/login';

function ButtonChecklist({
	locations,
	buttons,
	handleLoadButton,
	handleLoadChecklist,
	handleLoadResponses,
	loading,
	checklistsError,
	inProgress,
	checklists,
	responses,
	loadingResponse,
	handleDeleteCurrentInProgress,
	handleResetLoading,
	handleSendResponseResetLoader,
	isConnected,
	queChecklists,
	checklistloading
}) {
	const { locationId, buttonId } = useParams();
	const [showLoadMore, setShowLoadMore] = useState(false);
	const [showViewMore, setShowViewMore] = useState(false);
	const [queResponses, setQueResponses] = useState([]);
	const [currentResponses, setCurrentResponses] = useState([]);
	const [lastestDate, setLastestDate] = useState(null);
	const history = useHistory();
	const currentLocation = locations.find(({ id }) => id === locationId);
	const currentButton = buttons.find((button) => button?.id === buttonId);
	const field2 = currentButton?.field2;
	const field3 = currentButton?.field3;
	const field7 = currentButton?.field7;
	const field18 = currentButton?.field18;
	const contacts = field18 ? JSON.parse(decodeCMSEncoding(field18)).contacts : [];
	const checklistId = Number(field7);
	const currentChecklist = checklists.find((el) => Number(el.id) === checklistId);
	const isInProgress = inProgress ? inProgress.find((el) => Number(el.checklist) === checklistId) : false;
	let timer;


	useEffect(() => {
		const fetchConfig = async () => {
			const config = await login.getGlobalConfig();
			console.log(config,"config");
			if(config)
			{
				setShowViewMore(config?.ViewMore);
				setShowLoadMore(config?.LoadMore);
			}
		};
		fetchConfig();
	}, []);


	useEffect(() => {
		const filteredArr = [...responses].filter((response) => { return Number(response.field2) === Number(checklistId) }).sort((a, b) => (
			moment(b.dateField1, "MMM DD, YYYY h:mm:ss A").diff(moment(a.dateField1, "MMM DD, YYYY h:mm:ss A"))
		));
		const length = filteredArr.length;
		if (length > 0) {
			setCurrentResponses(filteredArr);
			setLastestDate(moment(filteredArr[length - 1]?.dateField1, "MMM DD, YYYY h:mm:ss A").valueOf());
		}
	}, [responses]);

	useEffect(() => {
		if (isConnected) {
			handleLoadChecklist(checklistId);
		}
	}, [locationId, buttonId]);
	useEffect(() => {
		if (isConnected) {
			if (currentButton) {
				return;
			}
			handleLoadButton(currentLocation);
		}
	}, [locationId, buttonId]);
	useEffect(() => {
		if (isConnected) {
			handleLoadResponses(field7, null);
		}
	}, [locationId, buttonId, checklistloading.loading, queChecklists]);

	useEffect(() => {
		const isActive = JSON.parse(currentChecklist?.field7 ?? true);
		if (!isActive) {
			Alert.alert(
				t('checklistNotActiveTitle'),
				t('checklistNotActiveMessage'),
				[
					{ text: 'OK', onPress: history.goBack },
				],
				{ cancelable: false },
			);
		}
		if (!currentChecklist && checklistsError) {
			// The most ugly dbl check... shame !
			// Easy fix for when they don't add a checklist to a button
			// I have to set timeout because sometimes loading is done but the currentchecklist is undefined
			timer = setTimeout(() => {
				if (!currentChecklist && checklistsError) {
					Alert.alert(
						t('buttonWithoutChecklistTitle'),
						t('buttonWithoutChecklistMessage'),
						[
							{ text: 'OK', onPress: () => { } },
						],
						{ cancelable: true },
					);
				}
			}, 1000);
		} else {
			clearTimeout(timer);
		}

		return () => {
			handleResetLoading();
			clearTimeout(timer);
		};
	}, [currentChecklist]);

	function actionsControl() {
		if (!currentChecklist && loading) {
			return <ActivityIndicator size="small" color={EStyleSheet.value('$grey')} />;
		}
		if (isInProgress && currentChecklist) {
			return (
				<>
					<IconListControl
						color={EStyleSheet.value('$blue')}
						title={t('Resume')}
						icon="md-checkbox-outline"
						to={{
							pathname: `/location/${locationId}/checklist/${checklistId}`,
							state: { type: ENUM_TYPE_CHECKLIST.UPDATE },
						}}
					// onPress={handleSendResponseResetLoader}
					/>
					<IconListControl
						color={EStyleSheet.value('$red')}
						title={t('Delete')}
						icon="trash-2"
						iconType="Feather"
						onPress={() => handleDeleteCurrentInProgress(checklistId)}
					/>
				</>
			);
		}
		return (
			<IconListControl
				color={EStyleSheet.value('$blue')}
				title={t('Start')}
				icon="md-checkbox-outline"
				to={{
					pathname: `/location/${locationId}/checklist/${checklistId}`,
					state: { type: ENUM_TYPE_CHECKLIST.CREATE },
				}}
			/>
		);
	}

	const recurrences = currentChecklist ? (currentChecklist?.field11 ?? '') : '';
	const [recurrence] = recurrences.split('::');

	const processQue = async () => {
		if(queChecklists.length>0)
		{

			const queChecklistArray = queChecklists && queChecklists.filter((item) => { return item.checklist == currentChecklist?.id });
			const QueResArray = [];
			await Promise.all(queChecklistArray?.map(async (checklist, index) => {
				const ChecklistRes = await convertQueCheckList(checklist, currentChecklist);
				ChecklistRes && QueResArray.push({ ...ChecklistRes, id: index + currentChecklist?.id });
			}));
			setQueResponses([...QueResArray]);
		}
		else{
			setQueResponses([]);
		}
	}
	useEffect(() => {
		processQue();
	}, [queChecklists, currentChecklist]);
	return (
		<ScrollView contentContainerStyle={styles.scrollInner}>
			<ButtonHeader
				location={currentLocation?.field2 || currentLocation?.id}
				title={field2 || ''}
				context={field3 || ''}
				icon="md-pin"
			/>
			{contacts.length > 0 && (
				<Content flex>
					{contacts.map((contact) => (
						<ContactPerson key={contact.email} contact={{ ...contact, firstName: contact.name, lastName: '' }} />
					))}
				</Content>
			)}
			<Content>
				<SubTitle capitalize title={recurrence} />
				{actionsControl()}
				<Separator blank />
				{currentChecklist && (
					<IconListControl
						color={EStyleSheet.value('$blueDark')}
						title={t('View Checklist')}
						icon="list"
						iconType="Feather"
						to={{ pathname: `/location/${locationId}/checklist/${checklistId}`, state: { type: ENUM_TYPE_CHECKLIST.VIEW } }}
					/>
				)}
				{queResponses?.length > 0 &&
					<View style={{ marginBottom: 20 }}>
						<SubTitle title="Queued" />
						<FlatList
							data={queResponses.reverse()}
							renderItem={({ item }) => (
								<React.Fragment key={item.id}>
									<ChecklistResponseItem response={item} queued={item} />
									<Separator flat />
								</React.Fragment>
							)}
						/>
					</View>
				}
				<SubTitle title="Response" />
				<View style={styles.list}>
					{loadingResponse && <ActivityIndicator size="small" color={EStyleSheet.value('$grey')} />}
					{!loadingResponse && !currentResponses.length && (
						<Paragraph>There is no response for this checklist yet.</Paragraph>
					)}
					<FlatList
						data={currentResponses}
						renderItem={({ item }) => (
							<React.Fragment key={item.id}>
								<ChecklistResponseItem response={item} />
								<Separator flat />
							</React.Fragment>
						)}
					/>
					{showLoadMore && currentResponses.length > 0 &&
						<View style={{ marginVertical: 10 }}>
							<Control
								disabled={loadingResponse}
								loading={loadingResponse}
								onPress={() => { handleLoadResponses(field7, lastestDate); }}
								title={t("Load more")}
							/>
						</View>
					}

					{showViewMore && currentResponses.length > 0 &&
						<View style={{ marginVertical: 10 }}>
							<Control
								onPress={() => {
									history.push(`/location/${locationId}/button/${buttonId}/checklist/${checklistId}/responses`, { type: ENUM_TYPE_CHECKLIST.READ });
								}}
								title={t("View More")}
							/>
						</View>
					}
				</View>
			</Content>
			<BlackPortal name="fab">
				<FloatActionButton locationId={locationId} />
			</BlackPortal>
		</ScrollView>
	);
}

const mapStateToProps = createStructuredSelector({
	locations: makeSelectLocations(),
	buttons: makeSelectButtons(),
	loading: makeSelectChecklistsLoading(),
	checklistsError: makeSelectChecklistsError(),
	checklists: makeSelectChecklists(),
	inProgress: makeSelectChecklistsInProgress(),
	responses: makeSelectResponses(),
	loadingResponse: makeSelectResponsessLoading(),
	isConnected: makeSelectNetworkIsConnected(),
	queChecklists: makeSelectQueChecklists(),
	checklistloading: makeSelectChecklistsLoadingSendResponse(),
});

export function mapDispatchToProps(dispatch) {
	return {
		handleLoadChecklist: (checklistId) => dispatch(loadChecklist(checklistId)),
		handleLoadResponses: (checklistId, date) => dispatch(loadResponses(checklistId, date)),
		handleDeleteCurrentInProgress: (checklistId) => dispatch(deleteCurrentInProgress(checklistId)),
		handleResetLoading: () => dispatch(resetLoading()),
		handleLoadButton: (location) => dispatch(loadButtons(location)),
		handleSendResponseResetLoader: () => dispatch(sendResponseResetLoader()),
	};
}

const withConnect = connect(
	mapStateToProps,
	mapDispatchToProps,
);

export default compose(
	withConnect,
	memo,
)(ButtonChecklist);
